import React from 'react'

import FormOption from './FormOption'

const RadioButton = props => <FormOption type="radio" {...props} />

RadioButton.displayName = 'RadioButton'

export default RadioButton
